import script from "./leftline2.vue?vue&type=script&setup=true&lang=js"
export * from "./leftline2.vue?vue&type=script&setup=true&lang=js"

import "./leftline2.vue?vue&type=style&index=0&id=63e70800&scoped=true&lang=css"
script.__scopeId = "data-v-63e70800"

export default script